import { type ButtonHTMLAttributes, forwardRef } from "react";

const base =
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring disabled:pointer-events-none disabled:opacity-50";

const variants = {
  primary: "bg-accent-600 text-white hover:bg-accent-700",
  secondary:
    "border border-border bg-surface text-text-primary hover:bg-surface-raised",
  ghost: "text-text-secondary hover:bg-neutral-100 dark:hover:bg-neutral-800",
  danger: "bg-danger-600 text-white hover:bg-danger-500",
  link: "text-accent-600 underline-offset-4 hover:underline",
};

const sizes = {
  sm: "h-8 px-3 text-xs",
  md: "h-9 px-4",
  lg: "h-10 px-6",
  icon: "h-9 w-9",
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof variants;
  size?: keyof typeof sizes;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = "primary", size = "md", className = "", ...props }, ref) => (
    <button
      ref={ref}
      className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    />
  ),
);

Button.displayName = "Button";
